import { render, staticRenderFns } from "./AcountItemHistory.vue?vue&type=template&id=56a79dd4"
import script from "./AcountItemHistory.vue?vue&type=script&lang=js"
export * from "./AcountItemHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports